import { CSSProperties, FC, HTMLProps, ReactNode } from 'react'

interface CenteredProps extends HTMLProps<HTMLDivElement> {
	children: ReactNode
	style?: CSSProperties
}

export const Centered: FC<CenteredProps> = ({ children, style, ...rest }) => {
	return (
		<div
			style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', ...style }}
			{...rest}>
			{children}
		</div>
	)
}
